import { useState } from "react";
import { toast } from "sonner";
import { MessageCircle, Check } from "lucide-react";
import { api } from "@/lib/api";
import { loadWaTemplate, normalizePhone, fillTemplate, waLink } from "@/lib/whatsapp";

export const WhatsAppButton = ({ appt, compact = false, onSent }) => {
  const [sentAt, setSentAt] = useState(appt.reminder_sent_at || "");
  const phone = normalizePhone(appt.client_phone);

  const send = async (e) => {
    e.stopPropagation();
    if (!phone) return toast.error("Il cliente non ha un numero di telefono: aggiungilo nella sua scheda");
    const win = window.open("", "_blank");
    try {
      const { template } = await loadWaTemplate();
      const url = waLink(phone, fillTemplate(template, appt));
      if (win) win.location.href = url; else window.location.href = url;
      const { data } = await api.post(`/appointments/${appt.id}/reminded`);
      setSentAt(data.reminder_sent_at);
      onSent?.();
    } catch (err) { win?.close(); toast.error("Impossibile preparare il messaggio"); }
  };

  const title = !phone ? "Numero di telefono mancante" : sentAt ? `Promemoria inviato il ${new Date(sentAt).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}` : "Invia promemoria WhatsApp";
  const base = "inline-flex items-center gap-1.5 rounded-full border transition-colors duration-200";
  const tone = !phone ? "border-[#E8E1D7] text-[#B8AFA3]" : "border-[#25D366]/40 text-[#128C4B] hover:bg-[#25D366]/10";

  return (
    <button type="button" onClick={send} title={title} className={`${base} ${tone} ${compact ? "h-8 px-2.5 text-xs" : "px-4 py-2 text-sm"}`} data-testid={`wa-reminder-${appt.id}`}>
      <MessageCircle className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
      {!compact && <span>Promemoria WhatsApp</span>}
      {sentAt && <Check className="h-3.5 w-3.5" data-testid={`wa-sent-${appt.id}`} />}
    </button>
  );
};
